import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Loader } from "../MainLoader/Loader";
import { trackEvent } from "@/app/utils/branch";

interface MenuCategoryProps {
  categories: any;
  categorySlug: any;
}

const MenuCategory: React.FC<MenuCategoryProps> = ({
  categories,
  categorySlug,
}) => {
  const [open, setOpen] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const pathName = usePathname();
  const segments = pathName.split("/");
  const lastSegment = segments.pop() || "";
  const basePath = pathName.split("/").slice(0, 2).join("/");

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const handleLoader = (item: any) => {
    setLoader(true);
    trackEvent("SERVICE_VIEW", item?.id);
  };

  const blankFunction = () => {};

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {categories?.map((item: any, index: any) => (
          <Link
            prefetch={false}
            key={index}
            href={
              categorySlug == undefined || categorySlug == ""
                ? item.slug
                : basePath + "/" + item.slug
            }
            passHref
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={
              lastSegment !== item.slug.trim().replace(/\s+/g, "%20")
                ? () => handleLoader(item)
                : blankFunction
            }
          >
            <ListItem disablePadding>
              <ListItemButton>
                <Image
                  src={item?.mobileImage?.secureHttpPath}
                  width={200}
                  height={200}
                  style={{
                    margin: "auto",
                    objectFit: "cover",
                    width: "3rem",
                    height: "3rem",
                    borderRadius: "100%",
                  }}
                  alt="category"
                />{" "}
                &nbsp; &nbsp;
                <ListItemText primary={item?.name} />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      {loader && <Loader />}
      <Button onClick={toggleDrawer(true)} color="success">
        <MenuOpenIcon
          sx={{
            color: "#15741a",
          }}
        />
      </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
};

export default MenuCategory;
